module.exports = __webpack_public_path__ + "static/img/jfdg.f0704b95.png";